// extracted by mini-css-extract-plugin
module.exports = {"subtitle":"ModalSubtitle_subtitle__30u4J"};